import { createContext } from 'react';

export default createContext(
    {
        custom: {},
        page: {}
    }
)
